<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>资料变更审核</h1>
        <p>渠道商提交的主体资料变更，通过后写回渠道档案。手机号不可变更。</p>
      </div>
    </div>
    <div class="ch-metrics three">
      <div class="ch-metric"><div class="k">申请数</div><div class="v">{{ list.length }}</div></div>
      <div class="ch-metric"><div class="k">待审核</div><div class="v">{{ count('PENDING') }}</div></div>
      <div class="ch-metric"><div class="k">已通过</div><div class="v">{{ count('APPROVED') }}</div></div>
    </div>
    <div class="ch-panel">
      <table class="ch-table">
        <thead>
          <tr>
            <th>渠道</th>
            <th>手机</th>
            <th>变更内容</th>
            <th>提交时间</th>
            <th>状态</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in list" :key="row.id">
            <td>{{ row.partnerName || row.currentName || '—' }}</td>
            <td>{{ row.partnerPhone || '—' }}</td>
            <td class="diff">
              <div v-for="item in diffs(row)" :key="item.label">
                <b>{{ item.label }}</b>：{{ item.from || '—' }} → {{ item.to || '—' }}
              </div>
              <span v-if="!diffs(row).length">无字段变化</span>
            </td>
            <td>{{ row.createdAt || '—' }}</td>
            <td>
              <span class="ch-tag" :class="row.status === 'APPROVED' ? 'ok' : (row.status === 'REJECTED' ? 'bad' : 'warn')">
                {{ statusText(row.status) }}
              </span>
              <div v-if="row.rejectReason" class="reason">{{ row.rejectReason }}</div>
            </td>
            <td>
              <button v-if="row.status === 'PENDING'" class="ch-link" type="button" @click="review(row, 'approve')">通过</button>
              <button v-if="row.status === 'PENDING'" class="ch-link" type="button" @click="review(row, 'reject')">驳回</button>
              <span v-else>—</span>
            </td>
          </tr>
          <tr v-if="!list.length"><td colspan="6" class="ch-empty">还没有资料变更申请</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { getChannelProfileChanges, reviewChannelProfileChange } from '@/api/admin'

const FIELDS = [
  { key: 'name', current: 'currentName', label: '主体' },
  { key: 'legalName', current: 'currentLegalName', label: '法人' },
  { key: 'idCardNo', current: 'currentIdCardNo', label: '身份证' },
  { key: 'licenseNo', current: 'currentLicenseNo', label: '执照号' },
  { key: 'regionCode', current: 'currentRegionCode', label: '区划' },
  { key: 'regionName', current: 'currentRegionName', label: '地区' },
  { key: 'industryCode', current: 'currentIndustryCode', label: '行业' }
]

export default {
  name: 'HqProfileChanges',
  data() { return { list: [] } },
  created() { this.load() },
  methods: {
    count(status) { return this.list.filter(item => item.status === status).length },
    statusText(status) {
      if (status === 'PENDING') return '待审核'
      if (status === 'APPROVED') return '已通过'
      if (status === 'REJECTED') return '已驳回'
      return status || '—'
    },
    diffs(row) {
      return FIELDS
        .map(field => ({
          label: field.label,
          from: row[field.current],
          to: row[field.key]
        }))
        .filter(item => String(item.from || '') !== String(item.to || ''))
    },
    async load() {
      const result = await getChannelProfileChanges()
      this.list = result.list || []
    },
    async review(row, action) {
      let reason = ''
      if (action === 'reject') {
        const input = await this.$prompt('驳回原因', '驳回资料变更')
        reason = input.value
      }
      await reviewChannelProfileChange(row.id, { action, reason })
      this.$message.success(action === 'approve' ? '已通过并生效' : '已驳回')
      this.load()
    }
  }
}
</script>

<style scoped>
.diff { font-size: 12px; line-height: 1.6; max-width: 360px; }
.diff b { color: #5a6578; font-weight: 600; }
.reason { margin-top: 4px; font-size: 12px; color: #c45656; }
</style>
